import React, { useEffect, useCallback, useState} from 'react';
import ResolutionDropdown from 'components/toolbar/ResolutionDropdown.js';
import {setQuantized} from 'actions/index.js';
import {connect} from 'react-redux';

const StepActions = ({setQuantized, quantized, track, color}) => { 
    const addSteps = useCallback(() => {
        track.sequencerEngine.doubleTrackLength(track.trackNumber);
    }, [track]);
    const removeSteps = useCallback(() => {
        track.sequencerEngine.halfTrackLength(track.trackNumber);
    }, [track]);

    const toggleQuantize = useCallback(() => {
        setQuantized(!quantized);
    }, [quantized]);

    let style = {
        backgroundColor: color
    };

    let quantizedStyle = {
        borderColor: color
    };

    return (
        <div className="step-actions">
          <ResolutionDropdown sequencerEngine={track.sequencerEngine}/>
          <div
            style={quantizedStyle}
            onClick={toggleQuantize}
            className={quantized ? "quantized quantize-button" : "quantize-button"}>
              {quantized ? 'Quantized' : 'Unquantized'}
          </div>
          <div style={style} onClick={addSteps} className="add-steps-btn">+</div>
          <div style={style} onClick={removeSteps} className="remove-steps-btn">-</div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      quantized: state.sequencer.quantized,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setQuantized: quantized => dispatch(setQuantized(quantized)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepActions);
